/**
 * Event Transport Layer for the Modals
 */
import Vue from 'vue'
const ModalBus = new Vue()
export default ModalBus